import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { academylist, listevent } from "../../../services/admin";
import moment from "moment";
export default function Addcalendar() {
  const [events, setEvents] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState("");

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");


  const openModal = (event) => {
    setSelectedEvent(event);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setSelectedEvent("");
    setModalIsOpen(false);
  };

  const handleEventClick = (info) => {
    const clickedEvent = {
      title: info.event.title,
      start: info.event.start,
      end: info.event.end,
      description: info.event.extendedProps.description,
      location: info.event.extendedProps.location,
      circular: info.event.extendedProps.circular === '' ? "" : info.event.extendedProps.path + info.event.extendedProps.circular,
    };
    openModal(clickedEvent);
  };

  useEffect(() => {

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setACList(arr);
        }
      }
    });
    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listall(arr[0]);
                
              }
            }
           
          }
        }
      });
    }else{
      listall("");
    }
  }, []);



  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e);
    } else {
      setAcaID("");
      listall("");
    }
  }

  function listall(lid) {
    setEvents([]);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && lid !== "") {
      temp.append("academy_id", lid.value);
    }
    listevent(temp).then((res) => {
      if (res.status === true) {
        setEvents(res.data.details);
      }
    })
  }
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Calendar Events</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Calendar</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Calendar Events
          </li>
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body">
                  {localStorage.getItem("Role") === "1" && (

                    <div className="row">
                      <div className="col-xl-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Select Academy{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <Select
                            className="default-select"
                            placeholder="Select Academy"
                            value={acaid}
                            options={aclist}
                            onChange={handleAcademy}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </div>

                    </div>
                  )}

                  <FullCalendar
                    plugins={[dayGridPlugin]}
                    initialView="dayGridMonth"
                    events={events.map(event => ({
                      title: event.event_name,
                      start: event.event_start,
                      end: event.event_end || event.event_start,
                      description: event.description,
                      location: event.location,
                      path: event.path,
                      circular: event.circular,
                      backgroundColor: '#b04751',
                      textColor: '#fff'
                    }))}
                    eventClick={handleEventClick}
                  />

                  <Modal show={modalIsOpen} size="md">
                    <Modal.Header>
                      <Modal.Title>Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="table-responsive">
                        <h4>{selectedEvent.title}</h4>
                        <p><strong>Start Date :</strong> {moment(selectedEvent.start).format('DD-MM-YYYY')}</p>
                                    <p><strong>End Date :</strong> {selectedEvent.end ? moment(selectedEvent.end).format('DD-MM-YYYY') : moment(selectedEvent.start).format('DD-MM-YYYY')}</p>

                        <p><strong>Location :</strong> {selectedEvent.location}</p>
                        <p><strong>Description :</strong> {selectedEvent.description}</p>
                        {selectedEvent.circular && <p><strong>Circular:</strong> <a href={selectedEvent.circular} target="_blank" rel="noopener noreferrer">View Circular</a></p>}

                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <a className="btn btn-info" onClick={closeModal}>
                        Close
                      </a>
                    </Modal.Footer>
                  </Modal>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
